import { ECheckboxColors } from '@components/common/Checkbox/Checkbox';
import AssetTypes from '@components/Map/MapControls/Controls/Filters/AssetsFilters/Tabs/AssetTypes';
import Attributes from '@components/Map/MapControls/Controls/Filters/AssetsFilters/Tabs/Attributes';
import Detailed from '@components/Map/MapControls/Controls/Filters/AssetsFilters/Tabs/Detailed';
import { ITabSection } from '@components/Map/TabSections/TabSections';

import { uuid } from '@utils/common';

import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

import { EColorAssetsBy } from '@enums/map';

import AssetState from './Tabs/AssetsState';

export const EAssetFilterNames = {
	assetType: 'Asset type',
	assetState: 'Asset state',
	attributes: 'Attributes',
	detailed: 'Detailed',
} as const;

export type TAssetFilterNames = TValueOfStringRecord<typeof EAssetFilterNames>

export const filterTabs: ITabSection[] = [
	{
		name: EAssetFilterNames.assetType,
		isActive: true,
		component: AssetTypes,
		id: uuid(),
		isDisabled: false,
	},
	{
		name: EAssetFilterNames.assetState,
		isActive: false,
		component: AssetState,
		id: uuid(),
		isDisabled: false,
	},
	{
		name: EAssetFilterNames.attributes,
		isActive: false,
		component: Attributes,
		id: uuid(),
		isDisabled: false,
	},
	{
		name: EAssetFilterNames.detailed,
		isActive: false,
		component: Detailed,
		id: uuid(),
		isDisabled: false,
		conditionDescription: 'To use this filter zoom the map',
	},
];

const { red, green, amber } = ECheckboxColors;

export const attributesFilters = [
	{
		name: 'Asset Site Availability Status',
		id: uuid(),
		fieldName: 'assetSiteAvailabilityStatus',
		items: [
			{ name: 'Out of service during construction work', isSelected: false, color: red, id: uuid() },
			{ name: 'Preservation area', isSelected: false, color: amber, id: uuid() },
			{ name: 'Under offer', isSelected: false, color: green, id: uuid() },
		],
	},
	{
		name: 'Power Supply Availability Status',
		id: uuid(),
		fieldName: 'powerSupplyAvailabilityStatus',
		items: [
			{ name: 'Distance >15m or Need to Cross Rd', isSelected: false, color: red, id: uuid() },
			{ name: 'Distance 5m-15m and Same Side Rd', isSelected: false, color: amber, id: uuid() },
			{ name: 'Distance <5m and Same Side Rd', isSelected: false, color: green, id: uuid() },
		],
	},
	{
		name: 'Backhaul Accessibility Status',
		id: uuid(),
		fieldName: 'backhaulAccessibilityStatus',
		items: [
			{ name: 'Distance >15m or Need to Cross Rd', isSelected: false, color: red, id: uuid() },
			{ name: 'Distance 5m-15m and Same Side Rd', isSelected: false, color: amber, id: uuid() },
			{ name: 'Distance <5m and Same Side Rd', isSelected: false, color: green, id: uuid() },
		],
	},
];

export const accessAvailabilityOptions = ['All', 'Yes', 'No'];

export const assetsColorOptions = [
	{ label: 'Nothing', value: EColorAssetsBy.none },
	{ label: 'Asset Site Availability Status', value: EColorAssetsBy.siteAvailability },
	{ label: 'Power Supply Availability Status', value: EColorAssetsBy.powerSupplyAvailability },
	{ label: 'Backhaul Accessibility Status', value: EColorAssetsBy.backhaulAccessibility },
];

